<style lang="scss" scoped>
.activity-title {
  padding: 0 12px;
  height: 50px;
  font-size: 18px;
  color: #333;
  line-height: 50px;
  border-bottom: #ebebeb;
}
.activity-detail {
  padding: 0 12px;
  font-size: 14px;
  color: #666;
  line-height: 25px;
}
</style>

<template>
  <div v-if="ruleStr" class="scroll-y activity-page">
    <div class="activity-title">规则说明</div>
    <div class="activity-detail" v-html="ruleStr"></div>
  </div>
</template>

<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import Url from '@mc/mc-utils/js/url/url'
import { API } from '@/api'
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '规则说明'
      })
      document.title = '规则说明'
      vm.getActivityInfoById()
    })
  },
  data() {
    return {
      ruleStr: ''
    }
  },
  methods: {
    getUrlParams() {
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}

      // eslint-disable-next-line camelcase
      const activity_id = query.activity_id || hashQuery.activity_id || ''
      return {
        activity_id
      }
    },
    async getActivityInfoById() {
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}

      // eslint-disable-next-line camelcase
      const activity_id = query.activity_id || hashQuery.activity_id || ''
      const params = { activity_id }
      try {
        const ruleStr = await API.cart.getActivityInfoById(params)
        this.ruleStr = ruleStr?.activity_rule_desc || ''
      } catch (e) {
        this.$catch(e)
      }
    }
  }
}
</script>
